export const ESTADO_CUENTA = {
  DISCOVERED: 1,
  ERROR: 2,
  EXPIRED: 3,
  PROCESSING: 4,
  READY: 5,
  SUSPENDED: 6,
} as const

export type EstadoCuentaBancariaType =
  (typeof ESTADO_CUENTA)[keyof typeof ESTADO_CUENTA]
